import fileLog from "../../../services/file-log/FileLog";
export default {
  data() {
    return {
      logData: [],
      rowsPerPageItems: [5, 10, 15, 20],
      headers: [
        {
          sortable: false,
          text: "Nombre del archivo",
          value: "plu",
          align: "left"
        },
        {
          sortable: false,
          text: "Fecha de error",
          align: "left"
        },
        {
          sortable: false,
          text: "Usuario",
          align: "left"
        }
      ],
      itemsData: []
    };
  },
  props: {},
  watch: {},
  methods: {
    getFileLog() {
      fileLog.getLog().then(response => {
        this.logData = response.data;
      });
    }
  },
  created() {
    this.getFileLog();
  }
};
